<script lang="ts">
	import Hero from '$lib/components/sections/Hero.svelte';
	import WhatIsAdmiral from '$lib/components/sections/WhatIsAdmiral.svelte';
	import DashboardPreview from '$lib/components/sections/DashboardPreview.svelte';
	import DesignPartnerStrip from '$lib/components/sections/DesignPartnerStrip.svelte';
	import Metrics from '$lib/components/sections/Metrics.svelte';
	import LiveTerminal from '$lib/components/sections/LiveTerminal.svelte';
	import PlatformPillars from '$lib/components/sections/PlatformPillars.svelte';
	import LatestPosts from '$lib/components/sections/LatestPosts.svelte';
	import FinalCTA from '$lib/components/sections/FinalCTA.svelte';
	import Architecture from '$lib/components/sections/Architecture.svelte';
	let { data } = $props();
</script>

<svelte:head>
	<title>Admiral - The Operating System for Edge Infrastructure</title>
	<meta
		name="description"
		content="Admiral is the fastest way to run a fleet of Linux devices. One platform to deploy, manage, and secure edge hardware from 10 devices to 10 million. The modern alternative to Mender and Balena for edge device management."
	/>
	<meta
		name="keywords"
		content="edge computing platform, IoT device management, Linux fleet management, OTA updates, edge infrastructure, embedded Linux, device orchestration, edge deployment, remote device management, container orchestration edge, fleet management software, industrial IoT platform, edge OS"
	/>

	<meta property="og:title" content="Admiral - The Operating System for Edge Infrastructure" />
	<meta
		property="og:description"
		content="Deploy, manage, and secure Linux device fleets from 10 devices to 10 million. Purpose-built for edge computing at scale."
	/>
	<meta property="og:image" content="https://admrl.co/android-chrome-512x512.png" />

	<meta name="twitter:title" content="Admiral - The Operating System for Edge Infrastructure" />
	<meta
		name="twitter:description"
		content="Deploy, manage, and secure Linux device fleets from 10 devices to 10 million. Purpose-built for edge computing at scale."
	/>
	<meta name="twitter:image" content="https://admrl.co/android-chrome-512x512.png" />

	{@html `<script type="application/ld+json">${JSON.stringify({
		"@context": "https://schema.org",
		"@type": "WebSite",
		"name": "Admiral",
		"url": "https://admrl.co",
		"description": "The operating system for edge infrastructure. Deploy, manage, and secure Linux device fleets at scale.",
		"potentialAction": {
			"@type": "SearchAction",
			"target": "https://admrl.co/blog?q={search_term_string}",
			"query-input": "required name=search_term_string"
		}
	})}</` + `script>`}

	{@html `<script type="application/ld+json">${JSON.stringify({
		"@context": "https://schema.org",
		"@type": "SoftwareApplication",
		"name": "Admiral",
		"applicationCategory": "DeveloperApplication",
		"operatingSystem": "Linux",
		"description": "Edge infrastructure management platform for deploying, managing, and securing Linux device fleets. OTA updates, container orchestration, fleet monitoring, and security compliance for IoT and edge computing.",
		"url": "https://admrl.co",
		"offers": {
			"@type": "Offer",
			"price": "0",
			"priceCurrency": "USD",
			"description": "Free tier for up to 5 devices"
		},
		"featureList": [
			"OTA system updates",
			"Container orchestration at the edge",
			"Fleet monitoring and observability",
			"Security and compliance automation",
			"Remote device access via SSH",
			"Immutable OS based on OCI images",
			"Multi-architecture support (x86, ARM)",
			"Rollback and canary deployments"
		]
	})}</` + `script>`}
</svelte:head>

<Hero />
<DashboardPreview />
<WhatIsAdmiral />
<DesignPartnerStrip />
<Metrics />
<LiveTerminal />
<PlatformPillars />
<Architecture />
<LatestPosts posts={data.latestPosts} authors={data.authors} />
<FinalCTA />
